(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-section"] && !Shopify.designMode) return;
  try {
    
  class CPSProduct extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      clearInterval(this._poll);
    }

    init() {
      if (this._ready) return;
      this._ready = true;

      this.form = this.querySelector('form');
      const json = this.querySelector('[data-cps-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.track = this.querySelector('[data-cps-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.thumbs = Array.from(this.querySelectorAll('[data-cps-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.cps__dot'));

      if (this.track) this.track.scrollLeft = 0;

      this.initGallery();
      this.initOptions();
      this.initQty();
      this.initBundlePrice();
      this.initSubmit();
    }

    /* ---------- Gallery ---------- */
    goTo(i) {
      if (!this.track || !this.slides[i]) return;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }

    setActive(i) {
      this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      const t = this.thumbs[i];
      if (t && t.parentElement) {
        t.parentElement.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
      }
    }

    initGallery() {
      if (!this.track) return;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i)));

      const prev = this.querySelector('[data-cps-prev]');
      const next = this.querySelector('[data-cps-next]');
      const index = () => Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (prev) prev.addEventListener('click', () => this.goTo(Math.max(0, index() - 1)));
      if (next) next.addEventListener('click', () => this.goTo(Math.min(this.slides.length - 1, index() + 1)));

      let timer;
      this.track.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.setActive(index()), 60);
      }, { passive: true });
    }

    /* ---------- Options / variants ---------- */
    selectedOptions() {
      return Array.from(this.querySelectorAll('[data-cps-option-group]')).map((g) => {
        const select = g.querySelector('select');
        if (select) return select.value;
        const checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    initOptions() {
      this.querySelectorAll('[data-cps-option-group]').forEach((g) => {
        g.addEventListener('change', () => this.onVariantChange());
      });
    }

    onVariantChange() {
      const selected = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));

      selected.forEach((val, i) => {
        const label = this.querySelector('[data-cps-selected="' + i + '"]');
        if (label) label.textContent = val;
      });

      const btn = this.querySelector('[data-cps-add]');
      const btnText = this.querySelector('[data-cps-add-text]');

      if (!variant) {
        if (btn) { btn.disabled = true; btnText.textContent = btn.dataset.labelUnavailable; }
        return;
      }

      const id = this.querySelector('[data-cps-id]');
      if (id) id.value = variant.id;

      const now = this.querySelector('[data-cps-now]');
      const compare = this.querySelector('[data-cps-compare]');
      const badge = this.querySelector('[data-cps-badge]');
      if (now) now.textContent = variant.price;
      if (compare) { compare.textContent = variant.compare; compare.hidden = !variant.onSale; }
      if (badge) {
        badge.hidden = !variant.onSale;
        badge.textContent = badge.textContent.replace(/\d+%/, variant.percent + '%');
      }

      if (btn) {
        btn.disabled = !variant.available;
        btnText.textContent = variant.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }

      if (variant.media) {
        const i = this.slides.findIndex((s) => Number(s.dataset.mediaId) === variant.media);
        if (i > -1) this.goTo(i);
      }

      if (this.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Bundle quantity thakle price abar quantity onujayi update hobe
      this._lastQty = null;
      this.updatePrice();

      this.dispatchEvent(new CustomEvent('cps:variant-change', { bubbles: true, detail: { variant } }));
    }

    /* ---------- Quantity ---------- */
    initQty() {
      const input = this.querySelector('[data-cps-qty]');
      if (!input) return;
      const minus = this.querySelector('[data-cps-qty-minus]');
      const plus = this.querySelector('[data-cps-qty-plus]');
      const set = (n) => { input.value = Math.max(1, n); input.dispatchEvent(new Event('change', { bubbles: true })); };
      minus.addEventListener('click', () => set((parseInt(input.value, 10) || 1) - 1));
      plus.addEventListener('click', () => set((parseInt(input.value, 10) || 1) + 1));
    }

    /* ---------- Bundle / quantity price sync ---------- */
    initBundlePrice() {
      try {
        this.fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD'
        });
      } catch (e) {
        this.fmt = null;
      }
      this._lastQty = null;

      const check = () => {
        const q = this.currentQty();
        if (q !== this._lastQty) {
          this._lastQty = q;
          this.updatePrice();
        }
      };

      this.addEventListener('input', check);
      this.addEventListener('change', check);
      this.addEventListener('click', () => setTimeout(check, 60));
      // Kaching programmatically value set kore, tai event na-o ashte pare
      this._poll = setInterval(check, 250);
      check();
    }

    currentQty() {
      const el = this.querySelector('[data-cps-qty]') || (this.form && this.form.querySelector('[name="quantity"]'));
      return Math.max(1, parseInt(el && el.value, 10) || 1);
    }

    currentVariant() {
      const id = this.querySelector('[data-cps-id]');
      return this.variants.find((v) => String(v.id) === String(id && id.value));
    }

    updatePrice() {
      const v = this.currentVariant();
      if (!v) return;
      const q = this.currentQty();
      const now = this.querySelector('[data-cps-now]');
      const compare = this.querySelector('[data-cps-compare]');
      const badge = this.querySelector('[data-cps-badge]');

      if (now) {
        now.textContent = q > 1 && this.fmt ? this.fmt.format((v.priceCents * q) / 100) : v.price;
      }
      // Bundle er real compare price / discount % Kaching er, tai guess na kore hide kora hocche
      if (compare) compare.hidden = q > 1 || !v.onSale;
      if (badge) badge.hidden = q > 1 || !v.onSale;
    }

    /* ---------- Add to cart ---------- */
    initSubmit() {
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => {
        if (this.dataset.mode !== 'ajax') return; // native submit -> goes to cart page
        e.preventDefault();

        const btn = this.querySelector('[data-cps-add]');
        const msg = this.querySelector('[data-cps-msg]');
        btn.disabled = true;

        fetch(this.dataset.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form)
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) throw new Error(data.description || data.message);
            msg.textContent = 'Added to cart';
            msg.className = 'cps__msg is-ok';
            msg.hidden = false;
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          })
          .catch((err) => {
            msg.textContent = err.message || 'Something went wrong';
            msg.className = 'cps__msg is-error';
            msg.hidden = false;
          })
          .finally(() => { btn.disabled = false; });
      });
    }
  }

  if (!customElements.get('cps-product')) customElements.define('cps-product', CPSProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
